export default __webpack_public_path__ + "static/prestashop-fa9f0af9b6344d9b3790d67812e09314.svg";